import { render, staticRenderFns } from "./WritingEditor.vue?vue&type=template&id=84f75a0e&scoped=true"
import script from "./WritingEditor.vue?vue&type=script&lang=js"
export * from "./WritingEditor.vue?vue&type=script&lang=js"
import style0 from "./WritingEditor.vue?vue&type=style&index=0&id=84f75a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f75a0e",
  null
  
)

export default component.exports